import { ViewUser } from "../../Types/User/ViewUserModel";
import { TableColumn } from "react-data-table-component";
import UserRoleModal from "../../Components/UiKits/Modal/UserModal/UserRoleModal";
import Badge from "../../CommonElements/Badge";
import { CustomCellInterFace } from "../../Types/TablesType";
import { Badges, Btn } from "../../AbstractElements";

const CustomBadge: React.FC<CustomCellInterFace> = ({ label, color }) => (
  <Badges pill color={color}>
    {label}
  </Badges>
);

const statusColorMap: Record<string, string> = {
  ACTIVE: "success",
  LOCKED: "secondary",
  BLOCKED: "danger",
  INACTIVE: "danger",
};

export const UserTableColumn: TableColumn<ViewUser>[] = [
  {
    name: "EMPLOYEE NO",
    selector: (row) => row.emp_no,
    sortable: true,
    center: false,
    width: "150px",
  },
  {
    name: "USERNAME",
    selector: (row) => row.username,
    sortable: true,
    center: false,
    width: "200px",
  },
  {
    name: "EMPLOYEE DETAILS",
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        {row.emp_name}
        {" ("}
        {row.job_title}
        {")"}
        {row.status_label === "BLOCKED" ? `\n Blocked: ${row.reason}` : ""}
      </div>
    ),
    sortable: true,
    center: false,
    width: "300px",
  },
  {
    name: "STATUS",
    selector: (row) => row.status_label,
    cell: (row) => (
      <>
        <CustomBadge
          color={statusColorMap[row.status_label] ?? "secondary"}
          label={row.status_label}
        />
      </>
    ),
    sortable: true,
    center: false,
    width: "150px",
  },

  {
    name: "DATE CREATED",
    selector: (row) => row.created_date,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        {row.created_by_user}
        {"\n"}
        {row.created_date}
      </div>
    ),
    sortable: true,
    width: "250px",
    center: false,
  },
  {
    name: "DATE MODIFIED",
    selector: (row) => row.updated_date,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        {row.updated_by_user}
        {"\n"}
        {row.updated_date}
      </div>
    ),
    sortable: true,
    width: "250px",
    center: false,
  },
  {
    name: "ACTION",
    sortable: true,
    center: false,
    cell: (row) => {
      if (!row) return null;
      return <UserRoleModal emp_no={row.emp_no || ""} />;
    },
    width: "200px",
  },
];
